// assets/vh-p2-einnahme.js — WP-P40 W6: Einnahme-Wegweiser. ES5-IIFE, 'use strict', kein
// Dauer-Timer (200-ms-Timer-Test, FALLEN.md #2 / CLAUDE.md §5.8) — reagiert nur auf 'change' der
// Formularfelder. Eigene Datei, lädt nichts nach (Ladestelle sections/vh-p2-kopf.liquid, danach
// assets/vh-p2.js falls die Seite auch p2-rechner/p2-prosa nutzt).
//
// Rechenkonstanten: mg/Tropfen = Stärke(%) × 0,5 (10 % = 5 mg/Tropfen bei 20 Tropfen/ml,
// 10-ml-Flasche; Quelle neustart-2026/abnahmen/p40/G-einnahme-korpus.md §4).
//
// Verzehrempfehlung der Öle (Nachtrag Inhaber N-Y17, 30.09.2026): Start-Empfehlung ist 2× täglich
// 4 Tropfen — das gilt AUCH für Neueinsteiger, die Eingabe "Erfahrung" ändert bei Ölen deshalb
// nichts an der Tropfenzahl mehr (wirkt weiterhin bei Sleep-/Relief-Öl). FIX-2210 (S5 Doppel-Audit): keine
// 30-bis-50-mg-Spanne und keine „Viele …“-Saetze mehr, Verweis auf das Etikett. Der
// Korpus-Median (3 Tropfen je Einnahme beim Einstieg) ist nur noch Hintergrundinfo, keine
// Berechnungsgrundlage mehr. Sleep-/Relief-Öl und Kapseln rechnen weiterhin NICHT über diese
// Formel, sondern zeigen die im Produktexport belegte Etikett-Spanne (kein erfundenes Schema).
(function () {
  'use strict';

  var VH_P2E_DATEN = {
    oel5: { typ: 'oel', mgProTropfen: 2.5, tropfen: 5 }, // SHOPCHECK-0510 Inhaber: 5 % = 2x 5 Tropfen
    oel10: { typ: 'oel', mgProTropfen: 5 },
    oel15: { typ: 'oel', mgProTropfen: 7.5 },
    oel24: { typ: 'oel', mgProTropfen: 12, tropfen: 2 }, // Inhaber 05.10.: 24 % = 2x 2 Tropfen
    sleep: { typ: 'label', neu: 3, erfahrung: 5, zeitText: 'abends', etikett: 'Am Abend 3 bis 5 Tropfen unter die Zunge geben, laut Etikett.' },
    relief: { typ: 'label', neu: 4, erfahrung: 6, zeitText: 'morgens', etikett: 'Am Morgen 4 bis 6 Tropfen unter die Zunge geben, laut Etikett.' },
    kapseln: { typ: 'kapsel', etikett: '1 bis 2 Kapseln pro Tag, laut Etikett.', beispiel: 'Ein Beispiel aus Kundenbewertungen: „1 Kapsel Vormittag und 1 Kapsel zur Nacht.“ — Ilona T. · verifizierte Bestellung' }
  };

  var fmt = function (n) {
    var r = Math.round(n * 10) / 10;
    return r.toLocaleString('de-DE', { maximumFractionDigits: 1 });
  };

  var boxen = document.querySelectorAll('[data-vh-p2-einnahme]');
  for (var b = 0; b < boxen.length; b++) {
    (function (box) {
      var datenEl = box.querySelector('#vh-p2e-daten') || box.querySelector('script[id^="vh-p2e-daten"]');
      var produkte = [];
      if (datenEl) {
        try { produkte = (JSON.parse(datenEl.textContent) || {}).produkte || []; } catch (e) { produkte = []; }
      }
      var select = box.querySelector('[data-vh-p2e="produkt"]');
      if (!select || !produkte.length) { return; }

      for (var p = 0; p < produkte.length; p++) {
        var opt = document.createElement('option');
        opt.value = produkte[p].schluessel;
        opt.textContent = produkte[p].titel + (produkte[p].verfuegbar ? '' : ' (derzeit nicht verfügbar)');
        opt.setAttribute('data-url', produkte[p].url);
        select.appendChild(opt);
      }

      var erfahrungInputs = box.querySelectorAll('[data-vh-p2e="erfahrung"]');
      var zeitInputs = box.querySelectorAll('[data-vh-p2e="zeit"]');
      var out = box.querySelector('[data-vh-p2e-out]');
      var cta = box.querySelector('[data-vh-p2e-cta]');
      var ctaLabel = box.querySelector('[data-vh-p2e-cta-label]');

      var gewaehlt = function (inputs) {
        for (var i = 0; i < inputs.length; i++) { if (inputs[i].checked) { return inputs[i].value; } }
        return null;
      };

      // Review-Fix (Hauptmodell-Sichtung 30.09.2026, G-09): keine Bewertungsanzahl nennen — auch
      // nicht im JS-Text. "Auswertung unserer Kundenbewertungen" statt "(Auswertung von 700
      // Bewertungen)".
      var pflicht = 'Orientierung auf Basis von Erfahrungen unserer Kundinnen und Kunden (Auswertung unserer Kundenbewertungen). Keine medizinische Beratung. Die empfohlene Verzehrmenge auf dem Etikett nicht überschreiten. Bei Medikamenteneinnahme, Schwangerschaft oder Stillzeit vorher ärztlich abklären.';

      var rendere = function () {
        var schluessel = select.value;
        var d = VH_P2E_DATEN[schluessel];
        var opt = select.options[select.selectedIndex];
        var titel = opt ? opt.textContent : '';
        var url = opt ? opt.getAttribute('data-url') : '';
        if (!d) { return; }
        var erfahrung = gewaehlt(erfahrungInputs) || 'neu';
        var zeit = gewaehlt(zeitInputs) || 'morgens';
        var html = '';

        if (d.typ === 'kapsel') {
          html += '<p><strong>' + titel + ':</strong> ' + d.etikett + '</p>';
          html += '<p>' + d.beispiel + '</p>';
        } else if (d.typ === 'label') {
          var tropfen = erfahrung === 'neu' ? d.neu : d.erfahrung;
          html += '<p><strong>Start-Empfehlung für ' + titel + ':</strong> ' + tropfen + ' Tropfen ' + d.zeitText + '.</p>';
          html += '<p>' + d.etikett + '</p>';
        } else {
          // N-Y17: Start-Empfehlung ist fest 2x taeglich 4 Tropfen, auch fuer Neueinsteiger.
          var tropfenProEinnahme = d.tropfen || 4;
          var einnahmenProTag = zeit === 'beides' ? 2 : 1;
          var tropfenProTag = tropfenProEinnahme * einnahmenProTag;
          var mgProTag = tropfenProTag * d.mgProTropfen;
          html += '<p><strong>Empfohlener Einstieg für ' + titel + ':</strong> 2× täglich ' + tropfenProEinnahme + ' Tropfen (morgens und abends) – das gilt auch für Neueinsteiger.</p>';
          if (zeit === 'beides') {
            html += '<p>Das ergibt ' + tropfenProTag + ' Tropfen am Tag ≈ ' + fmt(mgProTag) + ' mg CBD.</p>';
          } else {
            // Review-Fix (Hauptmodell-Sichtung 30.09.2026): klarere Formulierung statt
            // "Nur eine Einnahme ergäbe ... Üblich ist die Aufteilung ...".
            html += '<p>Sie haben „' + (zeit === 'abends' ? 'abends' : 'morgens') + '“ gewählt: dann ' + tropfenProEinnahme + ' Tropfen ' + zeit + ' (≈ ' + fmt(mgProTag) + ' mg CBD). Die Empfehlung ist 2× täglich – morgens und abends.</p>';
          }
          html += '<p>Maßgeblich ist die Verzehrempfehlung auf dem Etikett.</p>';
        }

        html += '<p class="vh-p2-einnahme__pflicht">' + pflicht + '</p>';
        if (out) { out.innerHTML = html; }
        if (cta && url) {
          cta.hidden = false;
          cta.href = url;
          if (ctaLabel) { ctaLabel.textContent = 'Zu ' + titel.replace(' (derzeit nicht verfügbar)', ''); }
        }
      };

      var felder = [select].concat([].slice.call(erfahrungInputs)).concat([].slice.call(zeitInputs));
      for (var f = 0; f < felder.length; f++) {
        felder[f].addEventListener('change', rendere);
      }
      rendere();
    })(boxen[b]);
  }
})();
